// extracted by mini-css-extract-plugin
export default {"menu":"UserPopup_menu__p4l23","menuItem":"UserPopup_menuItem__BsTm8"};